import React from "react";
import "./App.css";
import "./fonts/Gilroy-Light.ttf";
import "./fonts/Gilroy-Regular.ttf";
import "./fonts/PolySansTrial-Bulky.otf";
import "./fonts/PolySansTrial-Median.otf";
import "./fonts/PolySansTrial-Neutral.otf";
import "./fonts/KaushanScript-Regular.ttf";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Switch } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Programs from "./components/Programs";
import Events from "./components/Events";
import Contact from "./components/Contact";
import Tech from "./components/Tech";
import Loyola from "./components/Loyola";
import Medical from "./components/Medical";
import Literacy2022 from "./components/Literacy2022";
import Literacy2023 from "./components/Literacy2023";
import Scholarship from "./components/Scholarship";
import Blog from "./components/Blog";
import Opening from "./components/Opening";
import Resources from "./components/Resources";
import Summer from "./components/Summer";
import Scholars from "./components/Scholars";
import Tech2 from "./components/Tech2";
// import Login from "./components/Users/Login";
// import Signup from "./components/Users/Signup";
// import Booking from "./components/Users/Booking";
import Debate from "./components/Debate";
import Davos from "./components/Davos";
import Digital from "./components/OtherEvents/Digital";
import GreenStreet from "./components/OtherEvents/GreenStreet";
import Stem from "./components/OtherEvents/Stem";
import Utme from "./components/OtherEvents/Utme";
import InnovationHub from "./components/InnovationHub";
import FirstPost from "./components/Blog/components/FirstPost";

const theme = createTheme({
  typography: {
    fontFamily: {
      fontFamily: "GilroyLight",
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Switch>
            {/* <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/booking-form" component={Booking} /> */}
            <Route exact path="/contact-us" component={Contact} />
            <Route exact path="/blog" component={Blog} />
            <Route path="/resources" component={Resources} />
            <Route path="/innovation-hub" component={InnovationHub} />
            <Route
              exact
              path="/2026-06-10/ogbomosho-where-real-solutions-were-born"
              component={FirstPost}
            />
            <Route
              exact
              path="/Oluseun-Onigbinde-Resource-Centre-provides-free-JAMB-forms-to-indigent-students"
              component={Utme}
            />
            <Route
              exact
              path="/Empowering-the-Future-through-STEM-for-Sustainability"
              component={Stem}
            />
            <Route
              exact
              path="/Green-Streets-Taking-Actions-for-a-Cleaner-Tomorrow"
              component={GreenStreet}
            />
            <Route
              exact
              path="/Digital-Foundations-Building-Your-Computer-Confidence"
              component={Digital}
            />
            <Route
              exact
              path="/Oluseun-Onigbinde-to-attend-World-Economic-Forum-Annual-Meeting-2025"
              component={Davos}
            />
            <Route
              exact
              path="/inter-secondary-school-debate"
              component={Debate}
            />
            <Route
              exact
              path="/oluseun-onigbinde-tech-fellowship-2.0"
              component={Tech2}
            />
            <Route
              exact
              path="/afternoon-with-the-oluseun-onigbinde-scholars"
              component={Scholars}
            />
            <Route
              exact
              path="/oluseun-onigbinde-free-summer-coaching"
              component={Summer}
            />
            <Route
              exact
              path="/official-launching-of-oluseun-onigbinde-resource-centre"
              component={Opening}
            />
            <Route
              exact
              path="/oluseun-onigbinde-annual-scholarship"
              component={Scholarship}
            />
            <Route
              exact
              path="/oluseun-onigbinde-literacy-awards-2023"
              component={Literacy2023}
            />
            <Route
              exact
              path="/oluseun-onigbinde-literacy-awards-2022"
              component={Literacy2022}
            />
            <Route
              exact
              path="/ogbomosho-free-medical-outreach"
              component={Medical}
            />
            <Route
              exact
              path="/oluseun-onigbinde-tech-fellowship"
              component={Tech}
            />
            <Route
              exact
              path="/loyola-college-technology-lab"
              component={Loyola}
            />
            <Route exact path="/our-events" component={Events} />
            <Route exact path="/who-we-are" component={About} />
            <Route exact path="/what-we-do" component={Programs} />
            <Route exact path="/" component={Home} />
          </Switch>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
